import { staffRoutes } from 'routers/private/staff-routes';
import { userRoutes } from 'routers/private/user-routes';
import { templateRoutes } from 'routers/private/template-routes';
import { codeRoutes } from 'routers/private/code-routes';
import { allocationRoutes } from 'routers/private/allocation-routes';
import { campaignRoutes } from 'routers/private/campaign-routes';
import { partnerProgramRoutes } from 'routers/private/partner-program-routes';

export default [
  ...staffRoutes,
  ...userRoutes,
  ...templateRoutes,
  ...codeRoutes,
  ...allocationRoutes,
  ...campaignRoutes,
  ...partnerProgramRoutes
];
